import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './Component_ExpressionBuilder.scss';
import { _className, Button, Component_GenericRenderer, Grid, LL_H_C, LL_V_L, MenuBuilder, ModuleFE_MouseInteractivity, ModuleFE_Thunderstorm, ModuleFE_Toaster, ModuleFE_Utils, mouseInteractivity_PopUp, openContent, SimpleListAdapter, TS_Card, TS_Link, TS_PropRenderer, TS_Space } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, _keys, DateTimeFormat_yyyyMMDD, filterDuplicates, filterInstances, MimeType_json, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { TS_Icons } from '@nu-art/ts-styles';
import { Component_TermsAndExpression } from './components/terms-and-expressions/Component_TermsAndExpression.js';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { convertExpressionToSchemaFE } from '../../schema-converion-fe/convertExpressionToSchemaFE.js';
import { DefaultEditor_InputText, DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
import { TS_EditableItemStatus } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemStatus/TS_EditableItemStatus';
import { Dialog_ArticleEditor } from '../../../healthcare-space/index.js';
import { WarningDialog } from '../../../shared-dialogs/index.js';
import { DropDown_ExpressionType } from '../../../../_entity/expression/ui-components.js';
import { Component_FocusedEntityRef } from '@nu-art/ts-focused-object-frontend/components/Component_FocusedEntityRef';
import { ExpressionBuilder_SeverityDeclarations } from './components/severity-declerations/ExpressionBuilder_SeverityDeclarations.js';
import { AllExpressionTypes, createExpressionLabel, DBDef_Expression, ExpressionType_Deduction, ExpressionType_NormalRange, ExpressionType_ResolutionFunction, ExpressionType_Score, noVarExpressionTypes, OrgAccessLevel, valueType_Range } from '@app/hcs-shared';
import { hasDuplicateNameExpression } from '../../../../utils.js';
import { Component_HVValueMappingEditor } from './components/hv-value-mapping/Component_HVValueMappingEditor.js';
import { VariableWrapper } from '../../../../wrappers/index.js';
import { Component_TagEditor } from '../../../shared-components/index.js';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { DropDown_Variables, ModuleFE_Variable } from '../../../../_entity/variable/index.js';
import { ModuleFE_Expression } from '../../../../_entity/expression/index.js';
import { ConfigKeyFE_Scores } from '../../../../_entity/tag/index.js';
import { ModuleFE_Value } from '../../../../_entity/value/index.js';
import { ModuleFE_Reference, resolveReferenceDisplay } from '../../../../_entity/reference/index.js';
const ViewMode_Edit = 'edit';
const ViewMode_View = 'view';
export class Component_ExpressionBuilder extends TS_EditableItemComponent {
    componentDidMount() {
        window.onbeforeunload = (event) => {
            const hasChanges = this.state.editable.hasChanges();
            if (!hasChanges)
                return;
            event.preventDefault();
            return (event.returnValue = '');
        };
        if (this.state.editable.get('expressionType') !== ExpressionType_Score.dbKey)
            return;
        // if a score doesn't have a severity declaration create by default when editing it
        if (this.state.editable.item.associatedVar && !this.state.editable.item.severityDeclarations?.length) {
            const declarations = this.resolveSeverityRanges(ModuleFE_Variable.cache.unique(this.state.editable.item.associatedVar));
            this.state.editable.update('severityDeclarations', declarations);
        }
    }
    componentWillUnmount() {
        window.onbeforeunload = null;
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.savingInstance = state.editable.isSaving();
        state.usedExpressionVarIds = this.resolveUsedVariables(state);
        state.usedDeductionVarIds = this.resolveDeductionVarIds(state);
        return state;
    }
    //######################### Logic #########################
    refMenuBuilder = (e) => {
        const menuItems = [{
                label: 'Add Article Reference',
                onClick: () => Dialog_ArticleEditor.show(this.createdRefCallback)
            }];
        const id = 'expression-builder-ref-menu';
        const adapter = SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label }));
        const pos = { x: e.clientX, y: e.clientY };
        new MenuBuilder(adapter, pos, { x: 0, y: 1 })
            .setId(id)
            .setOnClick((path, item) => {
            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
            item.onClick?.();
        })
            .setOffset({ x: 0, y: 10 })
            .show();
    };
    createdRefCallback = async (ref) => {
        await this.state.editable.update('references', [...this.state.editable.item.references ?? [], ref._id]);
        this.forceUpdate();
    };
    deleteRef = async (ref) => {
        const expressionItem = this.state.editable.item;
        const refIndex = expressionItem.references?.indexOf(ref._id);
        if (refIndex !== -1) {
            expressionItem.references?.splice(refIndex, 1);
            await this.state.editable.update('references', expressionItem.references?.filter((reference, index) => index !== refIndex));
            this.forceUpdate();
        }
    };
    queryFiltersByExpressionType = {
        [ExpressionType_Score.dbKey]: item => item._tagIds.includes(ConfigKeyFE_Scores.get()),
        [ExpressionType_NormalRange.dbKey]: item => ModuleFE_Value.cache.unique(item.valueId)?.type === 'standard-range',
    };
    getQueryFilter = () => this.queryFiltersByExpressionType[this.state.editable.item.expressionType];
    saveAndPublish = async () => {
        const expressionItem = this.state.editable;
        await expressionItem.update('_isDraft', true);
        try {
            this.setState({ savingInstance: true }, async () => {
                await expressionItem.save();
                this.props.deselectExpression();
            });
        }
        catch (e) {
            ModuleFE_Toaster.toastError('Saving expression failed');
            if (this.state.savingInstance)
                this.setState({ savingInstance: false });
        }
    };
    delete = async () => {
        try {
            WarningDialog.showDelete({
                onConfirm: async () => {
                    await this.state.editable.delete();
                    this.props.deselectExpression();
                },
                warningMessages: ['Are you sure you want to delete this expression?'],
                executeButtonText: 'Delete',
                title: 'Delete',
            });
        }
        catch (err) {
            this.logError(err);
        }
    };
    copy = async () => {
        const expressionId = this.state.editable.item._id;
        if (!expressionId)
            return;
        WarningDialog.show({
            onConfirm: async () => this.props.copyExpression(expressionId),
            warningMessages: ['Are you sure you want to copy this expression?'],
            executeButtonText: 'Copy',
            title: 'Copy',
        });
    };
    getViewMode = () => {
        if (!this.state.editable.item._id)
            return ViewMode_Edit;
        const collectionPermission = ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Expression.permissions.collection.edit);
        const orgPermissionAssert = ModuleFE_Utils.getProcessor('assert-org-permission');
        const orgAccessLevel = orgPermissionAssert(this.state.editable.item);
        return (collectionPermission === AccessLevel.HasAccess && orgAccessLevel === OrgAccessLevel.write) ? ViewMode_Edit : ViewMode_View;
    };
    resolveLabelDuplications = (selectedVar) => {
        return ModuleFE_Expression.cache.filter(expression => {
            return expression.associatedVar === selectedVar._id;
        }).map(expression => expression.label);
    };
    resolveSeverityRanges = (variable) => {
        const dbValue = ModuleFE_Value.cache.unique(variable.valueId);
        if (!dbValue)
            throw new MUSTNeverHappenException(`cannot find db value with id ${variable.valueId}`);
        if (dbValue.type !== valueType_Range)
            return [];
        return dbValue.data.subsets.map(rangeId => ({ severityValue: rangeId }));
    };
    // Helper function to recursively collect variable IDs from expressions
    collectNestedExpressionVarIds(expressionId, usedVarIds) {
        const expression = ModuleFE_Expression.cache.unique(expressionId);
        if (!expression)
            return;
        if (expression.associatedVar) {
            usedVarIds.push(expression.associatedVar);
        }
        // collect all expression variable
        this.collectVariables(expression, usedVarIds);
    }
    resolveUsedVariables(state = this.state) {
        // assign the item in state to a const for easier access, also create an empty list of used var ids to return
        const item = state.editable.item;
        const usedVarIds = [item.associatedVar];
        // Collect All variables
        this.collectVariables(item, usedVarIds);
        // eventually return the list and filter duplicates
        return filterInstances(filterDuplicates(usedVarIds));
    }
    collectVariables(expression, usedVarIds) {
        expression.terms.forEach(term => {
            term.atoms.forEach(atom => {
                if (atom.leftHand?.type === 'variable') {
                    usedVarIds.push(atom.leftHand.id);
                }
                else if (atom.leftHand?.type === 'expression') {
                    this.collectNestedExpressionVarIds(atom.leftHand.id, usedVarIds);
                }
            });
        });
    }
    resolveDeductionVarIds(state = this.state) {
        const expression = state.editable.item;
        const usedDeductionVarIds = [];
        // if expression of type deduction, go over the value mapping and collect the object keys (they are var ids)
        if (expression.expressionType === ExpressionType_Deduction.dbKey) {
            const valueMapping = expression.valueMapping ?? {};
            _keys(valueMapping).forEach(key => usedDeductionVarIds.push(key));
        }
        return filterInstances(filterDuplicates(usedDeductionVarIds));
    }
    //######################### Render #########################
    renderAddRefButton = () => {
        if (this.getViewMode() !== ViewMode_Edit)
            return '';
        return _jsx(TS_PropRenderer.Horizontal, { label: 'References', children: _jsx(LL_H_C, { className: 'yes-no-container', children: _jsx(Button, { variant: 'secondary', onClick: this.refMenuBuilder, className: 'add-ref-btn', children: "+" }) }) });
    };
    addReferences = () => {
        const item = this.state.editable.item;
        return _jsxs(LL_V_L, { className: 'references-list', children: [this.renderAddRefButton(), item.references?.map((reference, index) => {
                    const dbRef = ModuleFE_Reference.cache.unique(reference);
                    switch (dbRef.type) {
                        case 'article':
                            return _jsx(TS_PropRenderer.Horizontal, { label: _jsx(TS_Space, { width: 50 }), children: _jsxs(LL_H_C, { className: 'ref-row', onContextMenu: e => {
                                        const menuItems = [{
                                                label: 'Edit Article Reference',
                                                onClick: () => Dialog_ArticleEditor.show(() => this.forceUpdate(), dbRef)
                                            }];
                                        const id = 'expression-builder-ref-menu';
                                        const adapter = SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label }));
                                        const pos = { x: e.clientX, y: e.clientY };
                                        new MenuBuilder(adapter, pos, { x: 0, y: 1 })
                                            .setId(id)
                                            .setOnClick((path, item) => {
                                            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                                            item.onClick?.();
                                        })
                                            .setOffset({ x: 0, y: 10 })
                                            .show();
                                    }, children: [_jsx(TS_Link, { url: dbRef.data.url, target: '_blank', children: resolveReferenceDisplay(dbRef) }), _jsx(ICONS.x.component, { className: 'clear-icon', onClick: () => this.deleteRef(dbRef) })] }) }, `ref-${index}`);
                    }
                })] });
    };
    getAssociatedVariablesMap = () => {
        const currentExpressionId = this.state.editable.item._id;
        const associatedVariablesMap = {};
        ModuleFE_Expression.cache.forEach(expression => {
            if (!expression.associatedVar)
                return;
            if (expression._id === currentExpressionId)
                return;
            (associatedVariablesMap[expression.associatedVar] ??= []).push(expression._id);
        });
        return associatedVariablesMap;
    };
    resolveAssociatedExpressionLabels = (expressionIds) => {
        if (!expressionIds?.length)
            return "";
        return expressionIds.map(id => ModuleFE_Expression.cache.unique(id)?.label ?? "Unnamed expression").join(", ");
    };
    renderVariableDropdownItem = (variable, associatedVariablesMap) => {
        const expressionIds = associatedVariablesMap[variable._id];
        if (!expressionIds?.length)
            return _jsx(_Fragment, { children: variable.name });
        return _jsxs(LL_H_C, { style: { gap: 6 }, children: [_jsx("span", { style: { color: '#999' }, children: variable.name }), _jsx(ICONS.information.component, { ...openContent.tooltip.right(`assoc-var-tooltip-${variable._id}`, () => _jsxs(_Fragment, { children: ["Already associated to: ", this.resolveAssociatedExpressionLabels(expressionIds)] })) })] });
    };
    renderVarInput = () => {
        const editableExpression = this.state.editable;
        const expressionType = editableExpression.get('expressionType');
        if (!expressionType
            || noVarExpressionTypes.includes(expressionType))
            return '';
        const queryFilter = this.getQueryFilter();
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Associated Variable', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => _jsx("div", { className: 'expression-builder__view-mode-label', children: ModuleFE_Variable.cache.unique(this.state.editable.get('associatedVar'))?.name ?? '-' })
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => {
                            const associatedVariablesMap = this.getAssociatedVariablesMap();
                            return _jsx(DropDown_Variables, { editable: editableExpression, prop: 'associatedVar', limitItems: 20, showErrorTooltip: true, caret: DropDown_DefaultCaret, disabled: !expressionType, queryFilter: queryFilter, renderer: variable => this.renderVariableDropdownItem(variable, associatedVariablesMap), onSelected: async (_var) => {
                                    if (!_var)
                                        return;
                                    const conflictingExpressionIds = associatedVariablesMap[_var._id];
                                    if (conflictingExpressionIds?.length) {
                                        const conflictingLabels = this.resolveAssociatedExpressionLabels(conflictingExpressionIds);
                                        ModuleFE_Toaster.toastError(`"${_var.name}" is already associated to: ${conflictingLabels}`);
                                        return;
                                    }
                                    const _expressionType = AllExpressionTypes.find(e => e.dbKey === expressionType).label;
                                    const labelDuplications = this.resolveLabelDuplications(_var);
                                    const label = createExpressionLabel(labelDuplications, _expressionType, _var);
                                    const severityDeclarations = this.resolveSeverityRanges(_var);
                                    await this.state.editable.updateObj({
                                        associatedVar: _var._id,
                                        label: label,
                                        severityDeclarations: severityDeclarations
                                    });
                                } }, expressionType);
                        }
                    }
                ] }) });
    };
    renderDuplicateExpressionNameIndication = () => {
        const hasNameDuplications = hasDuplicateNameExpression(this.state.editable.item);
        // if no duplication found exit
        if (!hasNameDuplications)
            return;
        return _jsx(ICONS.information.component, { ...openContent.tooltip.bottom('duplicate-expression-tooltip', () => _jsx(_Fragment, { children: "Expression with the same name exists" })) });
    };
    renderExpressionRelationsFields = () => {
        const expressionType = this.state.editable.get('expressionType');
        if (!expressionType)
            return '';
        return _jsxs(_Fragment, { children: [this.renderVarInput(), _jsx(TS_PropRenderer.Horizontal, { label: 'Expression Name', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                            {
                                key: ViewMode_View,
                                renderer: _jsx("div", { className: 'expression-builder__view-mode-label', children: this.state.editable.get('label') ?? '-' })
                            },
                            {
                                key: ViewMode_Edit,
                                renderer: () => _jsxs(LL_H_C, { className: 'expression-metadata__header-row', children: [_jsx(DefaultEditor_InputText, { showErrorTooltip: true, editable: this.state.editable, prop: 'label', value: this.state.editable.get('label'), onChange: async (expressionName) => {
                                                if (expressionName.length)
                                                    await this.state.editable.update('label', expressionName);
                                            }, placeholder: 'Enter expression name' }), this.renderDuplicateExpressionNameIndication()] })
                            }
                        ] }) })] });
    };
    renderYesNo = () => {
        const item = this.state.editable.item;
        const className = _className('yes-no', item.isEvidenceBased ? 'yes' : 'no');
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Evidence-based', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => _jsx("div", { className: 'expression-builder__view-mode-label', children: item.isEvidenceBased ? 'Yes' : 'No' })
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => _jsx(LL_H_C, { className: 'yes-no-container', children: _jsx(LL_V_L, { className: className, onClick: async () => {
                                    await this.state.editable.update('isEvidenceBased', !item.isEvidenceBased);
                                    this.forceUpdate();
                                }, children: item.isEvidenceBased ? 'Yes' : 'No' }) })
                    }
                ] }) });
    };
    renderAdvisorFormKey = () => {
        const item = this.state.editable.item;
        if (item.expressionType !== ExpressionType_Score.dbKey)
            return '';
        const className = _className(this.state.validationErrors?.includes('formKey') && 'validation-error');
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Advisor Form Key', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => {
                            const advisorFormKey = this.state.editable.get('advisorFormKey');
                            return _jsx("div", { className: 'expression-builder__view-mode-label', children: (advisorFormKey && advisorFormKey.length) ?? '-' });
                        }
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => _jsx(DefaultEditor_InputText_Optional, { editable: this.state.editable, prop: 'advisorFormKey', type: 'text', showErrorTooltip: true, placeholder: 'Enter advisor form key', value: item.advisorFormKey, className: className })
                    }
                ] }) });
    };
    renderSeverityDeclarations = () => {
        const expressionType = this.state.editable.get('expressionType');
        if (!expressionType || expressionType !== ExpressionType_Score.dbKey)
            return '';
        const editableSeverities = this.state.editable.editProp('severityDeclarations', []);
        return _jsx(ExpressionBuilder_SeverityDeclarations, { viewMode: this.getViewMode() === 'view', editable: editableSeverities });
    };
    renderExpressionMetadata = () => {
        const leftColumnClass = _className('left-column');
        return _jsxs(TS_Card, { className: 'score-info', children: [_jsxs(Grid, { className: leftColumnClass, children: [this.state.editable.item._id &&
                            _jsx(Component_GenericRenderer, { rendererKey: 'organization-permission-editor', props: {
                                    item: this.state.editable.item,
                                    module: ModuleFE_Expression,
                                    direction: 'Horizontal',
                                    // 25/7/24 Chen decided that no one should change expression organizations for now, all are Quai.
                                    // 25/7/24 Shlomi decided to keep Expressions under Organization Permissions, despite them not being able to be any other organization than Quai.
                                    disabled: true // Hence, the Organization Permission editor in Expression is disabled.
                                } }), this.renderTagGroups(), this.renderExpressionTypeDropDown(), this.renderExpressionRelationsFields(), this.renderAdvisorFormKey(), this.renderYesNo(), this.addReferences()] }), this.renderSeverityDeclarations()] });
    };
    renderTagGroups = () => {
        const uiTagGroups = VariableWrapper.dbTagsToUI(this.state.editable.get('tagGroups'));
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Tags', children: _jsx(Component_TagEditor, { tags: uiTagGroups, mandatoryRootTag: true, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id, onChange: async () => {
                    const tagGroups = VariableWrapper.getTagsForDB(uiTagGroups);
                    await this.state.editable.updateObj({ tagGroups });
                } }) });
    };
    renderExpressionTypeDropDown = () => {
        const expressionType = this.state.editable.get('expressionType');
        const disabled = expressionType === ExpressionType_ResolutionFunction.dbKey;
        const editableExpression = this.state.editable;
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Expression Type', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => _jsx("div", { className: 'expression-builder__view-mode-label', children: AllExpressionTypes.find(exprType => exprType.dbKey === editableExpression.get('expressionType'))?.label ?? 'Missing Type' })
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => (_jsx(DropDown_ExpressionType, { editable: editableExpression, prop: 'expressionType', disabled: disabled, showErrorTooltip: true, onSelected: async (value) => {
                                if (value === expressionType)
                                    return;
                                await this.state.editable.updateObj({
                                    'expressionType': value,
                                    'associatedVar': undefined,
                                    'label': undefined,
                                    'valueMapping': undefined,
                                    'severityDeclarations': undefined
                                });
                            } }))
                    }
                ] }) });
    };
    renderEditButtons = () => {
        const hasChanges = this.state.editable.hasChanges();
        const fileNameToSave = `${DateTimeFormat_yyyyMMDD.format()}_${this.state.editable.get('label')
            ?.replace(/\s/g, () => '_') ?? this.state.editable.get('_id')}`;
        return _jsxs(_Fragment, { children: [_jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: ViewMode_View,
                            renderer: () => _jsx(_Fragment, {})
                        },
                        {
                            key: ViewMode_Edit,
                            renderer: () => _jsxs(_Fragment, { children: [!this.props.slimHeader && _jsx(Button, { variant: 'primary', className: 'util-btn', disabled: this.state.savingInstance, onClick: async () => {
                                            return this.saveAndPublish();
                                        }, children: "Save & Publish" }), _jsx(Button, { variant: 'primary', className: 'util-btn', disabled: this.state.savingInstance, onClick: async () => {
                                            this.setState({ savingInstance: true }, async () => {
                                                await this.state.editable.save();
                                            });
                                        }, children: "Save" }), _jsx(Button, { variant: 'dangerous', disabled: !this.state.editable.item._id || this.state.savingInstance, onClick: this.delete, className: 'util-btn', children: "Delete" }), this.state.editable.item._id &&
                                        _jsx(Button, { variant: 'dangerous', disabled: !this.state.editable.item._id || this.state.savingInstance, onClick: this.copy, className: 'util-btn', children: "Copy" })] })
                        }
                    ] }), !this.props.slimHeader && _jsx(Button, { variant: 'secondary', onClick: async () => {
                        if (!hasChanges)
                            return this.props.deselectExpression();
                        WarningDialog.showDelete({
                            onConfirm: () => this.props.deselectExpression(),
                            warningMessages: ['Changes won\'t be saved, are you sure you wanna quit?'],
                            title: undefined,
                            executeButtonText: 'Delete',
                        });
                    }, className: 'util-btn', children: !hasChanges ? 'Close' : 'Cancel' }), !this.props.slimHeader && _jsx(Button, { variant: 'tertiary', className: 'util-btn', disabled: !this.state.editable.get('_id'), onClick: async () => {
                        const convertedExpression = convertExpressionToSchemaFE(this.state.editable.item);
                        ModuleFE_Thunderstorm.downloadFile({
                            fileName: fileNameToSave,
                            content: __stringify(convertedExpression, true),
                            mimeType: MimeType_json
                        });
                    }, children: _jsx(TS_Icons.download.component, {}) })] });
    };
    renderHeader = () => {
        const label = this.state.editable.item.label ?? 'New Expression';
        const shouldSeeSaveStatus = this.getViewMode() === ViewMode_Edit;
        return _jsxs(LL_H_C, { className: 'header', children: [_jsxs(LL_H_C, { className: 'flex__grow', style: { gap: '10px' }, children: [this.props.backButton
                            ? _jsx("div", { className: 'header__back', onClick: this.props.backButton.action, children: this.props.backButton.label })
                            : !this.props.slimHeader && _jsx(Button, { variant: 'primary', className: 'util-btn', onClick: () => this.props.deselectExpression(), children: '< List' }), _jsx("div", { className: 'main-title', ...openContent.tooltip.bottom('expression-builder__title', () => label), children: label }), _jsxs(LL_H_C, { className: 'status-components', children: [shouldSeeSaveStatus && _jsx(TS_EditableItemStatus, { editable: this.state.editable }), _jsx(Component_FocusedEntityRef, { focusedEntities: [{ dbKey: DBDef_Expression.dbKey, itemId: this.state.editable.item._id }] })] })] }), _jsx(LL_H_C, { className: 'buttons-container', children: this.renderEditButtons() })] });
    };
    renderTermsAndExpression = () => {
        return _jsxs(LL_V_L, { style: { gap: '5px' }, className: 'match_parent', children: [this.state.editable.get('expressionType') === ExpressionType_Deduction.dbKey && _jsx("div", { children: "If:" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: ViewMode_View,
                            renderer: () => _jsx(Component_TermsAndExpression, { hideDnD: true, viewMode: true, editable: this.state.editable })
                        },
                        {
                            key: ViewMode_Edit,
                            renderer: () => _jsx(Component_TermsAndExpression, { usedVarIds: this.state.usedDeductionVarIds, editable: this.state.editable })
                        }
                    ] })] });
    };
    renderValueMapping = () => {
        if (this.state.editable.get('expressionType') !== ExpressionType_Deduction.dbKey)
            return;
        const editableValueMapping = this.state.editable.editProp('valueMapping', { '': [] });
        return _jsxs(LL_V_L, { style: { gap: '5px' }, className: 'match_parent', children: [_jsx("div", { children: "Then:" }), _jsx(Component_HVValueMappingEditor, { mode: this.getViewMode(), editable: editableValueMapping, usedVarIds: this.state.usedExpressionVarIds })] });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'expression-builder', children: [this.renderHeader(), _jsxs(Grid, { className: 'builder-grid', children: [this.renderExpressionMetadata(), this.renderTermsAndExpression(), this.renderValueMapping()] })] });
    }
}
//# sourceMappingURL=Component_ExpressionBuilder.js.map